import { Fragment, useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { Button, Input, Label, Table } from "reactstrap";
import { getAdminCompanyDeviceContract } from "../../slices/admin/thunk";
import { useDispatch, useSelector } from "react-redux";
import CompanyDropdown from "./CompanyDropdownMenu";
import DeviceDropdown from "./DeviceDropdownMenu";
import LimitDropdown from "./LimitDropdown";
import { SELECTION_ALL } from "../../common/constants";
import AdminDeviceContractRow from "./AdminDeviceContractRow";
import AdminDeviceContractModal from "./AdminDeviceContractModal";
import { getDisplayDatetime } from "../../helpers/display_help";

function AdminDeviceContract(props) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    document.title = t('PageMain.DocumentTitle');
    const contracts = useSelector(state => state.Admin.contract);
    const [searchWord, setSearchWord] = useState("");
    const [isShowModal, setShowModal] = useState(false);
    const [modalDevice, setModalDevice] = useState(null);
    const [selectedCompany, setSelectedCompany] = useState(props.selectedCompany === null ? SELECTION_ALL : props.selectedDevice.companyID);
    const [selectedDevice, setSelectedDevice] = useState(props.selectedDevice === null ? SELECTION_ALL : props.selectedDevice.deviceID);
    const [limit, setLimit] = useState(20);
    const [isShowActiveOnly, setShowActiveOnly] = useState(true);
    const [isShowLatestOnly, setShowLatestOnly] = useState(true);

    async function fetchData(selectedDeviceID, selectedCompanyID) {
        console.log("fetchData", selectedDeviceID);
        dispatch(getAdminCompanyDeviceContract(selectedDeviceID, selectedCompanyID, limit, isShowActiveOnly, isShowLatestOnly));
    }

    useEffect(() => {
        fetchData(selectedDevice, selectedCompany);
    }, [limit, selectedDevice, selectedCompany, isShowActiveOnly, isShowLatestOnly])

    useEffect(() => {
        fetchData(props.selectedDevice);
        setSelectedDevice(props.selectedDevice.deviceID);
        setSelectedCompany(props.selectedDevice.companyID);
    }, [props.selectedDevice])

    const handleSelectCompany = (companyID) => {
        fetchData(selectedDevice, companyID);
        setSelectedCompany(companyID);
        setSelectedDevice(""); // Reset device selection when company changes
    };

    const handleSelectDevice = (deviceID) => {
        fetchData(deviceID, selectedCompany);
        setSelectedDevice(deviceID);
    };

    return (
        <Fragment>
            <div className="d-flex flex-row align-items-start justify-content-between">
                <div className="d-flex flex-row align-items-start justify-content-start">
                    <Button size="sm" color="primary" className="mb-2 me-2" onClick={()=>fetchData(selectedDevice, selectedCompany)}>{t('Common.Btn.Refresh')}</Button>
                    <div className="mb-3">
                        <Input
                            name="searchWord"
                            className="form-control"
                            placeholder={t('Common.Btn.Search')}
                            type="text"
                            value={searchWord}
                            onChange={(event) => {
                                setSearchWord(event.target.value);
                            }}
                        />
                    </div>
                    <CompanyDropdown onChange={handleSelectCompany} companyID={selectedCompany} />
                    <DeviceDropdown onChange={handleSelectDevice} companyID={selectedCompany} deviceID={selectedDevice} />
                    <LimitDropdown
                        selectedCompany={selectedCompany}
                        selectedDevice={selectedDevice}
                        limit={limit}
                        setLimit={setLimit}
                    />
                     <div className="form-check ms-3 mt-1" >
                        <Input className="form-check-input" type="checkbox" checked={isShowActiveOnly} id="is-contract-active-only-check"  onChange={(e) => setShowActiveOnly(e.target.checked)}/>
                        <Label className="form-check-label" htmlFor="is-contract-active-only-check">{t('PageAdmin.Btn.DisplayActiveContractOnly')}</Label>
                    </div>
                     <div className="form-check ms-3 mt-1" >
                        <Input className="form-check-input" type="checkbox" checked={isShowLatestOnly} id="is-contract-latest-only-check"  onChange={(e) => setShowLatestOnly(e.target.checked)}/>
                        <Label className="form-check-label" htmlFor="is-contract-latest-only-check">{t('PageAdmin.Btn.DisplayLatestContractOnly')}</Label>
                    </div>
                </div>
                <Button size="sm" color="secondary" className="mb-2 me-2" onClick={() => { setModalDevice(null); setShowModal(true); }}>{t('PageAdmin.Btn.CreateDeviceContract')}</Button>
            </div>


            <div className="device-table" style={{ maxHeight: '100%', overflowY: 'auto' }}>
                <Table className="table-nowrap mb-3">
                    <thead className="table-light sticky-header">
                        <tr>
                            <th scope="col">{t('PageAdmin.CompanyDeviceContractTable.ContractID')}</th>
                            <th scope="col">{t('PageAdmin.CompanyDeviceContractTable.DeviceID')}</th>
                            <th scope="col">{t('PageAdmin.CompanyDeviceContractTable.SystemDeviceID')}</th>
                            <th scope="col">{t('PageAdmin.CompanyTable.Name')}</th>
                            <th scope="col">{t('PageAdmin.CompanyDeviceContractTable.StartDatetime')}</th>
                            <th scope="col">{t('PageAdmin.CompanyDeviceContractTable.EndDatetime')}</th>
                            <th scope="col">{t('PageAdmin.CompanyDeviceContractTable.LastUpdatedAt')}</th>
                            <th scope="col">{t('PageAdmin.CompanyDeviceContractTable.LastUpdatedBy')}</th>
                            <th scope="col">{t('PageAdmin.CompanyDeviceContractTable.Remark')}</th>
                            <th scope="col">{t('PageAdmin.CompanyDeviceContractTable.Action')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {contracts.map((d) => {
                            console.log("contracts", d);
                            if (searchWord !== "" &&
                                d.remark.indexOf(searchWord) === -1 &&
                                d["device"]["admin_company"]["name"]?.indexOf(searchWord) === -1 &&
                                d["start_date"]?.indexOf(searchWord) === -1 &&
                                d["end_date"]?.indexOf(searchWord) === -1 &&
                                getDisplayDatetime(d["created_at_epoch"] * 1000)?.indexOf(searchWord) === -1 &&
                                d["updatedByUser"]["username"]?.indexOf(searchWord) === -1 &&
                                d["remark"]?.indexOf(searchWord) === -1 
                            ) {
                                return null;
                            }
                            return (
                                <AdminDeviceContractRow
                                    data={d}
                                    key={d.id}
                                    onClickModify={() => {
                                        setModalDevice(d); setShowModal(true);
                                    }}
                                    onSelectedDeviceUpdate={props.onSelectedDeviceUpdate}
                                />
                            );
                        })}
                    </tbody>
                </Table>
                <AdminDeviceContractModal show={isShowModal} onCloseClick={()=>{setShowModal(false)}} data={modalDevice} selectedCompany={selectedCompany} fetchData={() => fetchData(selectedDevice, selectedCompany)}/>
            </div>
        </Fragment>
    );
}

export default AdminDeviceContract;